import { TextFieldProps } from '@material-ui/core'

import { TextInput } from './TextInput'

export const TextArea = ({ minRows = 10, ...rest }: TextFieldProps) => (
  <TextInput minRows={minRows} multiline {...rest} />
)
